import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Contract State Filter]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)

export const setState = createAction(
    `${ SOURCE } SetState`, props<{ filter: any }>(),
)

export const setContractStateFilterProperty = createAction(
    `${ SOURCE } SetProperty`, props<{ property: string; value: any }>(),
)

export const toggleContractStateFilterProperty = createAction(
    `${ SOURCE } ToggleProperty`, props<{ property: string; value: any }>(),
)